export default "/_next/static/images/55e42c3ceead00ce51ae2da237140c6e.jpg";